module.exports = __webpack_public_path__ + "static/section-background.fdcf41b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/section-background.png
// module id = ./src/assets/section-background.png
// module chunks = 35783957827783